import dayjs, { Dayjs } from 'dayjs'

export function getTZOffset(date?: Date | Dayjs | string): string {
  const offset = dayjs(date).format('Z')

  return offset
}
